export const userType = {
  Suppliers: ["SUPPLIER"],
  IncomingParts: ["INCOMIG PARTS"],
};
